import React from "react";
import { Dialog } from "primereact/dialog";
import { ProgressBar } from "primereact/progressbar";
import classNames from "classnames";
import AnttButton from "../../../../../vendors/components/Button";
import "../assets/evento-contribuicao.scss";

export interface SalvamentoEtapa {
  key: string;
  label: string;
}

interface Props {
  visible: boolean;
  etapas: SalvamentoEtapa[];
  etapaAtual: string | null;
  dispositivoAtual?: number;
  totalDispositivos?: number;
  sucesso?: boolean;
  protocolo?: string;
  exibirAvisoEmail?: boolean;
  tituloSucesso?: string;
  subtituloSucesso?: string;
  onClose?: () => void;
}

function getEtapaStatus(
  etapaKey: string,
  etapaAtual: string | null,
  etapas: SalvamentoEtapa[]
) {
  if (!etapaAtual) {
    return "pending";
  }

  const currentIndex = etapas.findIndex((e) => e.key === etapaAtual);
  const etapaIndex = etapas.findIndex((e) => e.key === etapaKey);

  if (etapaIndex < currentIndex) {
    return "done";
  }
  if (etapaIndex === currentIndex) {
    return "active";
  }
  return "pending";
}

export default function OverlaySalvamentoContribuicao({
  visible,
  etapas,
  etapaAtual,
  dispositivoAtual,
  totalDispositivos,
  sucesso = false,
  protocolo,
  exibirAvisoEmail = false,
  tituloSucesso = "Contribuição enviada com sucesso",
  subtituloSucesso = "Recebemos seus dados e os anexos enviados.",
  onClose,
}: Props) {
  const currentIndex = etapaAtual
    ? etapas.findIndex((e) => e.key === etapaAtual)
    : -1;
  const progressValue = sucesso
    ? 100
    : currentIndex >= 0
    ? Math.round(((currentIndex + 1) / etapas.length) * 100)
    : 0;

  const showDispositivo =
    !sucesso &&
    dispositivoAtual != null &&
    totalDispositivos != null &&
    totalDispositivos > 1;

  const header = sucesso ? (
    <div className="salvamento-overlay__success-header">
      <span className="salvamento-overlay__success-icon">
        <i className="pi pi-check-circle" />
      </span>
      <div className="salvamento-overlay__success-heading">
        <h3 className="salvamento-overlay__success-title">{tituloSucesso}</h3>
        <p className="salvamento-overlay__success-subtitle">
          {subtituloSucesso}
        </p>
      </div>
    </div>
  ) : (
    "Salvando sua contribuição"
  );

  return (
    <Dialog
      header={header}
      visible={visible}
      onHide={() => {}}
      closable={false}
      dismissableMask={false}
      draggable={false}
      modal
      style={{ width: "460px" }}
      className={classNames("salvamento-overlay-dialog", {
        "salvamento-overlay-dialog--success": sucesso,
      })}
    >
      <div className="salvamento-overlay">
        {showDispositivo && (
          <p className="salvamento-overlay__dispositivo">
            Dispositivo {dispositivoAtual} de {totalDispositivos}
          </p>
        )}

        <div className="salvamento-overlay__progress-header">
          <span className="salvamento-overlay__progress-label">
            PROGRESSO DO ENVIO
          </span>
          <span className="salvamento-overlay__progress-value">
            {progressValue}%
          </span>
        </div>

        <ProgressBar
          value={progressValue}
          showValue={false}
          className="salvamento-overlay__progress"
        />

        <ul className="salvamento-overlay__steps">
          {etapas.map((etapa) => {
            const status = sucesso
              ? "done"
              : getEtapaStatus(etapa.key, etapaAtual, etapas);
            return (
              <li
                key={etapa.key}
                className={classNames("salvamento-overlay__step", {
                  "salvamento-overlay__step--done": status === "done",
                  "salvamento-overlay__step--active": status === "active",
                  "salvamento-overlay__step--pending": status === "pending",
                })}
              >
                <span className="salvamento-overlay__step-icon">
                  {status === "done" && <i className="pi pi-check-circle" />}
                  {status === "active" && (
                    <i className="pi pi-spin pi-spinner" />
                  )}
                  {status === "pending" && <i className="pi pi-circle" />}
                </span>
                <span className="salvamento-overlay__step-label">
                  {etapa.label}
                </span>
              </li>
            );
          })}
        </ul>

        {sucesso ? (
          <>
            {!!protocolo && (
              <div className="salvamento-overlay__protocolo">
                <div className="salvamento-overlay__protocolo-info">
                  <span className="salvamento-overlay__protocolo-label">
                    NÚMERO DO PROTOCOLO
                  </span>
                  <span className="salvamento-overlay__protocolo-value">
                    {protocolo}
                  </span>
                </div>
                {exibirAvisoEmail && (
                  <span className="salvamento-overlay__protocolo-email">
                    Confirmação enviada por e-mail
                  </span>
                )}
              </div>
            )}

            <p className="salvamento-overlay__aviso">
              A contribuição poderá ser alterada até o período final de
              contribuição.
            </p>

            <div className="salvamento-overlay__actions">
              <AnttButton label="Fechar" onClick={() => onClose && onClose()} />
            </div>
          </>
        ) : (
          <p className="salvamento-overlay__footer">Não feche esta página.</p>
        )}
      </div>
    </Dialog>
  );
}
